import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { ThemeProvider } from '@material-ui/core/styles';
import MyTheme from '../../MyTheme';

export function ServiceDisabledScreen() {
    return (
        <ThemeProvider theme={MyTheme}>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="100vh"
                padding={2}
            >
                <Paper
                    elevation={4}
                    style={{
                        maxWidth: 560,
                        width: '100%',
                        padding: '48px 32px',
                        textAlign: 'center',
                        background: 'rgba(255, 255, 255, 0.85)',
                        backdropFilter: 'blur(20px)',
                        WebkitBackdropFilter: 'blur(20px)',
                        borderRadius: 20,
                        border: '1px solid rgba(209, 213, 219, 0)',
                        boxShadow: '4px 2px 50px rgba(0, 0, 0, 0.2)',
                    }}
                >
                    <img
                        className="logo"
                        src="logo.svg"
                        alt="logo_Drakkar"
                        style={{ maxWidth: '7rem', width: '100%', marginBottom: 24 }}
                    />
                    <Typography variant="body1" color="textSecondary">
                        O serviço está desativado por tempo indeterminado.
                    </Typography>
                </Paper>
            </Box>
        </ThemeProvider>
    );
}
